/**
 * What VesselFinder's two filter drawers — Port Calls and Expected Arrivals —
 * open on.
 *
 * Shared rather than declared twice because they are the same promise made in
 * two places: a drawer that opens ready to run, with a window narrow enough
 * and a row count small enough that the first click is cheap. Both endpoints
 * price per unit returned, so the limit IS the spend dial, and a default that
 * drifted apart between the two forms would quietly mean two different prices
 * for the same gesture.
 *
 * Pure model file: no `@angular/*`, no `leaflet`, no `this` (rule R1) — see
 * `client/src/app/components/leaflet-newcollections/ais/NEW-AIS-WIZARD.md`
 * Part 5.
 */

/** Rows/vessels requested when the form opens — 10 keeps the opening spend small. */
export const VF_DEFAULT_LIMIT = 10;

/** Max age of the returned events/positions, in minutes. */
export const VF_DEFAULT_INTERVAL_MINUTES = 60;

/**
 * Today in UTC as "YYYY-MM-DD" — the format `<input type="date">` reads and
 * writes, and UTC because both forms label their date fields "(UTC)" and
 * stamp them as UTC before sending.
 */
export function vfTodayUtc(): string {
  return new Date().toISOString().slice(0, 10);
}
